import React, { Component } from 'react'

export default class SkeletonSubscriptionItem extends Component {
    render() {
        return (
            <div className="c-skeleton__subscription-item mt-30"></div>
        )
    }
}